import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=674b9af0&scoped=true&"
import script from "./editGoods.vue?vue&type=script&lang=js&"
export * from "./editGoods.vue?vue&type=script&lang=js&"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=674b9af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b9af0",
  null
  
)

export default component.exports